import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/homePage/index.vue'
import DetailPage from '../views/detailPage/index.vue'
import ipqDetailPage from '../views/ipqDetailPage/index.vue'
import qnDetailPage from '../views/qnDetailPage/index.vue'
import ocDetailPage from '../views/ocDetailPage/index.vue'

import detail from '../views/detail/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'HomePage', component: HomePage, meta: { title: 'Path Academics' } },
  { path: '/planA', name: 'planA', component: HomePage, meta: { title: 'Path Academics' } },
  { path: '/detailPage', name: 'DetailPage', component: DetailPage, meta: { title: '项目列表' } },
  { path: '/ipqDetailPage', name: 'ipqDetailPage', component: ipqDetailPage, meta: { title: '项目列表' } },
  { path: '/qnDetailPage', name: 'qnDetailPage', component: qnDetailPage, meta: { title: '项目列表' } },
  { path: '/ocDetailPage', name: 'ocDetailPage', component: ocDetailPage, meta: { title: '项目列表' } },
  { path: '/detail', name: 'detail', component: detail, meta: { title: '海报' } },
  { path: '*', redirect: { name: 'HomePage' } }
]

const router = new VueRouter({ mode: 'history', routes })
router.beforeEach((to, from, next) => {
  // // 获取用户代理信息
  const userAgent = navigator.userAgent.toLowerCase()
  // 判断是否在微信小程序中打开
  if (userAgent.indexOf('miniprogram') !== -1) {
    // 如果在小程序中打开，则修改路由的标题为小程序的标题
    document.title = '集思未来科研项目'
    // 继续路由跳转
    next()
  } else {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta ? to.meta.title : 'Path Academics'
    }
    next()
  }
  // /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   document.title = to.meta ? to.meta.title : 'Path Academics'
  // }
  // next()
})
export default router
